module.exports = __webpack_public_path__ + "img/transitional-period.e6e93f61.svg";